import useAPI from '@/hooks/useAPI';
import ActivityLogsRepository from '@/repositories/ActivityLogsRepository';

const useUniqueActivityLogEvents = (enabled = true) => {
  const activityLogsRepository = ActivityLogsRepository();

  return useAPI({
    queryKey: ['getUniqueEventNames'],
    queryFn: async () => {
      return await activityLogsRepository.getUniqueEventNames();
    },
    enabled
  });
};

export default useUniqueActivityLogEvents;
